import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const useAlignmentStore = create(
  devtools((set, get) => ({
    // Alignment Tool
    alignment: {
      flexumAngle: 5,
      adbAdd: 3,
      anteroPost: 0,
      lrTranslation: 0,
      subPatellarHeight: 45
    },

    // Actions
    setAlignment: (data) => set({ alignment: { ...get().alignment, ...data } }),

    // Reset all data
    reset: () => set({
      alignment: {
        flexumAngle: 5,
        adbAdd: 3,
        anteroPost: 0,
        lrTranslation: 0,
        subPatellarHeight: 45
      }
    })
  }))
);

export default useAlignmentStore;